// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup
        .object()
        .shape({
            files: yup.array().of(yup.object().shape({}).nullable()).nullable(),
            tempFoldersName: yup.string().nullable(),
            description: yup
                .string()
                .required(intl.formatMessage({ id: 'ui-comp-formvalidation-description-required' }))
                .nullable()
        })
        .test({
            name: 'validateQuillEmptyNote',
            message: intl.formatMessage({ id: 'ui-comp-formvalidation-description-required' }),
            test: (note) => note?.description !== '<p><br></p>'
        })
        .nullable();

export default validationSchema;
